/**
 * ProjectNewPage - Router for project creation flows
 *
 * Routes to different components based on URL params:
 * - ?fromTemplate=<id> → ProjectCreatePage (old form for template-based creation)
 * - ?isTemplate=true → ProjectCreatePage (old form for creating templates)
 * - No params → ProjectWizard (new 4-step wizard)
 */
import { useSearchParams } from 'react-router-dom';
import { ProjectCreatePage } from './ProjectCreatePage';
import { ProjectWizard } from '@/components/wizard/ProjectWizard';

export function ProjectNewPage() {
  const [searchParams] = useSearchParams();

  // Check for template-related params that need the old form
  const fromTemplate = searchParams.get('fromTemplate');
  const isTemplate = searchParams.get('isTemplate') === 'true';

  // Use old form for template flows, wizard for fresh creation
  if (fromTemplate || isTemplate) {
    return <ProjectCreatePage />;
  }

  return <ProjectWizard />;
}
